import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { getActiveLanguage, Language } from '@teamfoster/sdk/language-ngrx';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Collection, Filter } from '../models';
import { GraphQLService } from './graph-ql.service';
import { catalogProductResult } from './product-queries';
@Injectable({
  providedIn: 'root',
})
export class SlugsService extends GraphQLService {
  // language$!: Observable<string>;

  constructor() {
    super();
  }

  getCollectionSlugById(id: string, language?: string) {
    const query = this.client.query(`@inContext(language: ${language})`, (root: any) => {
      root.add('shop', (shop: any) => {
        shop.add('name');
      });
      root.add('collection', { args: { id } }, (collection: any) => {
        collection.add('handle');
      });
    });

    return from(this.client.send(query)).pipe(
      map((a: any) => {
        if (!a['data'].collection) {
          return null;
        }

        return { ...a['data'].collection };
      })
    ) as Observable<any>;
    // return from(this.client.send(query)).pipe(map(({ data, model }) => data.collectionByHandle));
  }

  getProductSlugById(id: string, language?: string) {
    const query = this.client.query(`@inContext(language: ${language})`, (root: any) => {
      root.add('shop', (shop: any) => {
        shop.add('name');
      });
      root.add('product', { args: { id } }, (product: any) => {
        product.add('handle');
      });
    });

    return from(this.client.send(query)).pipe(
      map((a: any) => {
        if (!a['data'].product) {
          return null;
        }

        return { ...a['data'].product };
      })
    ) as Observable<any>;
    // return from(this.client.send(query)).pipe(map(({ data, model }) => data.collectionByHandle));
  }
}
